import banner from '../img/banner.png';
import { Typography } from '@mui/material';
import { Box } from '@mui/system';
//import { Alert, AlertTitle } from '@mui/material';
import { useLanguage } from "../LanguageContext";

export default function Home({ isMobile }: { isMobile: boolean }) {
  const { language } = useLanguage();

  return (
    <Box
      sx={{
        minHeight: '100vh', // Allow content to grow if needed
        paddingX: { xs: '5%', sm: '10%' }, // Horizontal padding
        paddingY: { xs: '10%', sm: '5%' }, // Vertical padding
        display: 'flex',
        alignItems: { xs: 'flex-start', sm: 'center' }, // Top-align on mobile
        justifyContent: 'flex-start',
        scrollSnapAlign: 'start',
        overflowX: 'hidden', // Prevent horizontal scrolling
        position: 'relative',
      }}>
      {/* Fixed background Box */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundImage: `url(${banner})`,
          backgroundSize: 'cover',
          backgroundPosition: { xs: 'right center', sm: 'center center' }, // Right side on mobile
          zIndex: -1,
        }}/>

      <Box
        sx={{
          color: 'white',
          width: { xs: '100%', sm: 'auto' }, // Full width on mobile
          maxWidth: { xs: '100%', sm: '60%', md: '50%' }, // Limit width on larger screens
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
          textAlign: 'left',
          zIndex: 1,
          padding: { xs: '0 10px', sm: '0' }, // Extra padding on mobile
          boxSizing: 'border-box', // Ensure padding doesn't increase width
        }}
      >
        {/* Registration Deadline Alert */}
        {/*<Alert
          severity="warning"
          sx={{
            width: '100%', // Full width within container
            marginBottom: { xs: '1.5rem', sm: '2rem' },
            backgroundColor: 'rgba(255, 244, 229, 0.9)',
            color: '#663c00',
            fontSize: { xs: '0.9rem', sm: '1rem' },
            padding: { xs: '0.5rem', sm: '1rem' },
            boxSizing: 'border-box', // Prevent overflow
          }}>
          <AlertTitle sx={{ fontSize: { xs: '1rem', sm: '1.25rem' } }}>
            {language === "en" ? "Registration Closed" : "Regisztráció Lezárult"}
          </AlertTitle>
          {language === "en"
            ? "The registration deadline for the conference has passed. In case you haven't heard back from us, please contact us at dr.susanna.agora@gmail.com. Thank You!"
            : "A konferencia regisztrációs határideje lejárt. Amennyiben nem kapott visszajelzést jelentkezésére, kérjük jelezze felénk a dr.susanna.agora@gmail.com címen. Köszönjük!"}
        </Alert>*/}

        <Typography
          variant="h1"
          sx={{
            fontWeight: 'bold',
            marginBottom: '3%',
            fontSize: { xs: '1.8rem', sm: '3rem', lg: '4.5rem' },
            wordWrap: 'break-word', // Ensure long words wrap
          }}>
          {language === "en" ? "Play & Society" : "Játék és társadalom"}
        </Typography>

        <Typography
          variant="h2"
          sx={{
            marginBottom: '2%',
            whiteSpace: { xs: 'normal', sm: 'nowrap' }, // Wrap on mobile
            fontSize: { xs: '1.2rem', sm: '2rem', lg: '2.5rem' },
            wordWrap: 'break-word',
          }}>
          {language === "en" ? "International Conference 2025" : "Nemzetközi Konferencia 2025"}
        </Typography>

        <Typography
          variant="h3"
          sx={{
            fontWeight: 'bold',
            whiteSpace: { xs: 'normal', sm: 'nowrap' }, // Wrap on mobile
            fontSize: { xs: '1.1rem', sm: '2rem', lg: '2.5rem' },
            wordWrap: 'break-word',
          }}>
          {language === "en" ? "New Opportunities of Social Innovation" : "A társadalmi innováció új lehetőségei"}
        </Typography>

        <Typography
          variant="h3"
          sx={{
            fontWeight: 'bold',
            marginBottom: '5%',
            fontSize: { xs: '0.9rem', sm: '1.75rem', md: '2rem' },
            wordWrap: 'break-word',
          }}>
          {language === "en" ? "University of Pécs, Hungary" : "Pécsi Tudományegyetem"}
        </Typography>

        <Typography
          variant="h4"
          sx={{
            fontWeight: 'bold',
            marginBottom: '5%',
            fontSize: { xs: '0.9rem', sm: '1.75rem', md: '2rem' },
            wordWrap: 'break-word',
          }}>
          {language === "en" ? "9–10 MAY, 2025" : "2025 MÁJUS 9–10."}
        </Typography>

      </Box>
    </Box>
  )
}